function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, isEqual } from '@cloud-sn/v-utils';
import { normalizeContent, getChildNodeKeys, isDisabledNode, getNodeParentKeys } from '../utils';
import Selector from '../selector';
import SearchInput from '../searchInput';
export default {
  methods: {
    onRemove: function onRemove(e, node) {
      var disabled = this.disabled,
          innerValue = this.innerValue,
          setInnerValue = this.setInnerValue,
          treeCheckable = this.treeCheckable,
          treeCheckStrict = this.treeCheckStrict,
          fieldValue = this.normalizeFieldNames.value,
          clearDisabled = this.clearDisabled,
          selectedNodes = this.selectedNodes,
          setSelectionNodes = this.setSelectionNodes;
      e.stopPropagation();

      if (disabled) {
        return;
      }

      var removeValObj = {};

      if (!isDisabledNode(node, treeCheckable) || clearDisabled) {
        removeValObj = _objectSpread({}, removeValObj, _defineProperty({}, node.value, 1));
      } // deselect children


      if (treeCheckable && !treeCheckStrict) {
        var parentKeys = treeCheckStrict ? [] : getNodeParentKeys(node, fieldValue, treeCheckable, clearDisabled).reduce(function (r, k) {
          var nr = r;
          nr[k] = 1;
          return nr;
        }, {});
        removeValObj = _objectSpread({}, removeValObj, {}, parentKeys, {}, getChildNodeKeys(node, fieldValue, treeCheckable, clearDisabled).reduce(function (r, v) {
          var nr = r;
          nr[v] = 1;
          return nr;
        }, {}));
      }

      var values = innerValue.filter(function (v) {
        return !(v in removeValObj);
      });
      var nodes = selectedNodes.filter(function (item) {
        return values.indexOf(item.key) !== -1;
      });
      setSelectionNodes(nodes);
      setInnerValue(values);
    },
    renderSelections: function renderSelections() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          prevSelectionValue = this.prevSelectionValue,
          getSelectionValue = this.getSelectionValue,
          maxTagCount = this.maxTagCount,
          maxTagPlaceholder = this.maxTagPlaceholder,
          maxTagTextLength = this.maxTagTextLength,
          labelInValue = this.labelInValue,
          clearDisabled = this.clearDisabled,
          treeCheckable = this.treeCheckable,
          onRemove = this.onRemove,
          forceUpdateTriggerAlign = this.forceUpdateTriggerAlign,
          placeholder = this.placeholder,
          searchInputValue = this.searchInputValue;
      var selectionValue = getSelectionValue();
      this.prevSelectionValue = selectionValue;
      var selections = selectionValue;
      var maxCnt = Number(maxTagCount);

      if (maxCnt >= 0 && maxCnt < selectionValue.length) {
        selections = selections.slice(0, maxCnt);
      }

      var selectionNodes = selections.map(function (v) {
        var _choiceCls;

        var isCanRemove = !isDisabledNode(v, treeCheckable) || clearDisabled;
        var choiceCls = (_choiceCls = {}, _defineProperty(_choiceCls, "".concat(prefixCls, "-selection__choice"), true), _defineProperty(_choiceCls, "".concat(prefixCls, "-selection__choice__disabled"), !isCanRemove), _choiceCls);
        return h("li", {
          "class": choiceCls
        }, [isCanRemove ? h("span", {
          "class": "".concat(prefixCls, "-selection__choice__remove"),
          "on": {
            "click": function click($event) {
              return onRemove($event, v);
            }
          }
        }) : null, h("span", {
          "class": "".concat(prefixCls, "-selection__choice__content")
        }, [normalizeContent(maxTagTextLength, v.label || v.value)])]);
      });

      if (maxCnt >= 0 && maxCnt < selectionValue.length) {
        var tagTxt = "+ ".concat(selectionValue.length - maxCnt, " ...");

        if (isFunction(maxTagPlaceholder)) {
          var extraSelections = selectionValue.slice(maxCnt); // eslint-disable-next-line

          tagTxt = maxTagPlaceholder(labelInValue ? extraSelections : extraSelections.map(function (v) {
            return v.value;
          }));
        } else if (typeof maxTagPlaceholder === 'string') {
          tagTxt = maxTagPlaceholder;
        }

        tagTxt = normalizeContent(maxTagTextLength, tagTxt);
        selectionNodes.push(h("li", {
          "class": "".concat(prefixCls, "-selection__choice")
        }, [h("span", {
          "class": "".concat(prefixCls, "-selection__choice__content")
        }, [tagTxt])]));
      }

      selectionNodes.push(h("li", {
        "class": "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline")
      }, [h(SearchInput, {
        "attrs": {
          "align": true
        }
      })]));

      if (!isEqual(prevSelectionValue, selectionValue)) {
        forceUpdateTriggerAlign();
      }

      var placeholderNode = selectionValue.length === 0 && !searchInputValue ? h("span", {
        "class": "".concat(prefixCls, "-selection__placeholder")
      }, [placeholder]) : null;
      return h(Selector, {
        "slot": "trigger",
        "attrs": {
          "selections": selectionValue
        }
      }, [h("ul", {
        "class": "".concat(prefixCls, "-selection__rendered")
      }, [selectionNodes]), placeholderNode]);
    },
    renderMultipleTrigger: function renderMultipleTrigger() {
      var renderSelections = this.renderSelections;
      return renderSelections();
    }
  }
};